import { useEffect } from 'react';
import { getSpineManager } from '../../lib/spine-manager';
import { useToolStore } from '../../stores/toolStore';

interface GridOverlayProps {
  canvasWidth: number;
  canvasHeight: number;
}

export default function GridOverlay({ canvasWidth, canvasHeight }: GridOverlayProps) {
  const gridVisible = useToolStore((s) => s.gridVisible);

  useEffect(() => {
    const manager = getSpineManager();
    manager.drawArtboard(canvasWidth, canvasHeight);
    manager.fitToArtboard(canvasWidth, canvasHeight);
  }, [canvasWidth, canvasHeight]);

  useEffect(() => {
    getSpineManager().setGridVisible(gridVisible);
  }, [gridVisible]);

  return null;
}
